const validate = (value, { min }) => Number(value) === 0 || Number(value) >= min;

export default {
  validate,
  message: 'El campo {_field_} debe ser mayor a {min} o de lo contrario 0 (zero)',
  params: ['min'],
};
